{
  "common": {
    "cancel": "Abbruch",
    "delete": "Löschen",
    "remove": "Löschen",
    "edit": "Ändern",
    "restore": "Restore",
    "back": "Back",
    "submit": "Ok",
    "continue": "Continue",
    "save": "Speichern",
    "done": "Done",
    "home": "Home",
    "noData": "No data.",
    "confirm": "Confirm",
    "more": "Mehr",
    "close": "Close",
    "loading": "Loading",
    "menu": "Menu",
    "reset": "Reset",
    "search": "Search"
  },
  "pageMetaResolver": {
    "category": {
      "title": "{{count}} Ergebnis für {{query}}",
      "title_plural": "{{count}} Ergebnisse für {{query}}"
    },
    "checkout": {
      "title": "Ihre Bestellung",
      "title_plural": "Ihre Bestellung"
    },
    "search": {
      "title": "{{count}} Ergebnisse für \"{{query}}\"",
      "title_plural": "{{count}} Ergebnisse für \"{{query}}\"",
      "findProductTitle": "{{count}} result for coupon \"{{coupon}}\"",
      "findProductTitle_plural": "{{count}} results for coupon \"{{coupon}}\""
    },
    "product": {
      "description": "{{description}}",
      "heading": "{{heading}}",
      "title": "{{title}}"
    }
  },
  "spinner": {
    "loading": "Loading..."
  },
  "navigation": {
    "shopAll": "Shop all {{ navNode}} >"
  },
  "searchBox": {
    "placeholder": "Hier Suchbegriff eingeben...",
    "help": {
      "insufficientChars": "Please type more characters",
      "noMatch": "Ihre Suche lieferte keine Ergebnisse.",
      "exactMatch": "{{ term }}",
      "empty": "Ask us anything"
    }
  },
  "sorting": {
    "date": "Date",
    "orderNumber": "Order Number",
    "rma": "Return Number",
    "replenishmentNumber": "Replenishment Number",
    "nextOrderDate": "Next Order Date"
  },
  "httpHandlers": {
    "badGateway": "A server error occurred. Please try again later.",
    "badRequestPleaseLoginAgain": "Die eingegebene Nutzerkennung oder das eingegebene Passwort ist nicht korrekt. Geben Sie die Informationen erneut ein.",
    "badRequestOldPasswordIncorrect": "Altes Passwort falsch",
    "badRequestGuestDuplicateEmail": "{{ errorMessage }} email already exist. Please checkout with a different email to register using a guest account.",
    "conflict": "Already exists.",
    "erpTimeout":"Aufgrund einer technischen Störung ist diese Funktion derzeit nicht möglich. Bitte versuchen Sie es später nochmal.",
    "forbidden": "Sie sind nicht berechtigt, diese Aktion auszuführen. Bitte wenden Sie sich an Ihren Administrator, wenn Sie der Meinung sind, dass dies ein Fehler ist.",
    "gatewayTimeout": "The server did not respond, please try again later.",
    "internalServerError": "An Internal Server Error occurred. Please try again later.",
    "sessionExpired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "unknownError": "An unknown error occurred",
    "wrongCmsSiteError": "Sie können sich nur in {{ shopName }} einloggen, deshalb wurden Sie umgeleitet und müssen sich hier nochmal einloggen.",
    "resetPasswordNotAllowedError": "Sie sind Unterbenutzer oder Filiale dieses Geschäfts. Ihr Passwort kann nicht automatisch zugeschickt werden, sondern muss vom Inhaber Ihres Geschäfts im Bereich Mein RIO geändert werden.",
    "unknownIdentifierError": "{{ errorMessage }}",
    "illegalArgumentError": "{{ errorMessage }}",
    "unauthorized": {
      "common": "An unknown authorization error occured",
      "invalid_client": "Bad client credentials"
    },
    "validationErrors": {
      "missing": {
        "card_cardType": "The selected credit card is not supported. Please select another.",
        "card_accountNumber": "The credit card number entered is not valid.",
        "card_cvNumber": "The security code entered is not valid.",
        "card_expirationMonth": "The credit card expiration date entered is not valid.",
        "card_expirationYear": "The credit card expiration date entered is not valid.",
        "billTo_firstName": "The first name entered is not valid.",
        "billTo_lastName": "The last name entered is not valid.",
        "billTo_street1": "The address entered is not valid.",
        "billTo_street2": "The address entered is not valid.",
        "billTo_city": "The city entered is not valid for this credit card.",
        "billTo_state": "The state/province entered is not valid for this credit card.",
        "billTo_country": "The country entered is not valid for this credit card.",
        "billTo_postalCode": "The zip/postal code is not valid for this credit card.",
        "country": {
          "isocode": "Missing country"
        }
      },
      "invalid": {
        "card_expirationMonth": "The credit card expiration date entered is not valid.",
        "firstName": "Vorname hat kein gültiges Format.",
        "lastName": "Nachname hat kein gültiges Format.",
        "password": "Password entered is not valid.",
        "newPassword" : "Bitte geben Sie ein Kennwort ein, welches sich zu den letzten 4 verwendeten Kennwörtern unterscheidet.",
        "uid": "UID is not valid.",
        "code": "Code ist ungültig.",
        "email": "E-mail ist ungültig.",
        "passwordPolicyException": "Leider konnte das neue Kennwort nicht gespeichert werden. Bitte achten Sie auch darauf, dass sich das neue Kennwort zu den letzten 4 verwendeten Kennwörtern unterscheidet."
      }
    },
    "cartNotFound": "Cart not found.",
    "invalidCodeProvided": "Invalid code provided."
  },
  "miniCart": {
    "item": "{{count}} item currently in your cart",
    "item_plural": "{{count}} items currently in your cart",
    "total": "{{total}}",
    "count": "{{count}}"
  },
  "miniLogin": {
    "userGreeting": "{{name}}",
    "signInRegister": "Anmelden"
  },
  "skipLink": {
    "skipTo": "Skip to",
    "labels": {
      "header": "Header",
      "main": "Main Content",
      "footer": "Footer",
      "productFacets": "Product Facets",
      "productList": "Product List"
    }
  },
  "formErrors": {
    "labeled": {
      "required": "Feld {{label}} ist erforderlich",
      "cxInvalidEmail": "Feld {{label}} hat kein gültiges E-Mail-Format. Es muss dem folgenden Muster entsprechen: beispiel@ihredomäne.com",
      "cxInvalidPassword": "Feld {{label}} hat kein gültiges Kennwortformat",
      "cxMinOneUpperCaseCharacter": "Kennwort muss mindestens einen Großbuchstaben enthalten",
      "cxMinOneDigit": "Kennwort muss mindestens eine Ziffer enthalten.",
      "cxMinOneSpecialCharacter": "Kennwort muss mindestens ein Sonderzeichen enthalten",
      "cxMinSixCharactersLength": "Kennwort muss mindestens 6 Zeichen enthalten",
      "cxMinEightCharactersLength": "Kennwort muss mindestens 8 Zeichen enthalten",
      "cxMaxCharactersLength": "Kennwort darf nicht mehr als 128 Zeichen haben",
      "cxContainsSpecialCharacters": "Kennwort darf keine Sonderzeichen enthalten",
      "cxNoConsecutiveCharacters": "Kennwort darf keine aufeinanderfolgende identische Zeichen enthalten",
      "date": {
        "required": "Feld {{label}} ist erforderlich",
        "min": "Feld {{label}} darf nicht vor dem {{min}} sein",
        "max": "Feld {{label}} darf nicht nach dem {{max}} sein",
        "pattern": "Verwenden Sie im Feld {{label}} das Datumsformat yyyy-mm-dd",
        "invalid": "Verwenden Sie ein gültiges Datum im Feld {{label}}"
      }
    },
    "globalMessage": "The form you are trying to submit contains errors.",
    "required": "Das ist ein Pflichtfeld.",
    "cxInvalidEmail": "Die eingegebene Mailadresse ist nicht korrekt.",
    "cxInvalidPassword": "Das Passwort hat ein ungültiges Format",
    "cxPasswordsMustMatch": "Die Passwortbestätigung muss mit Ihrem Passwort übereinstimmen",
    "cxEmailsMustMatch": "E-Mail Adressen stimmen nicht überein",
    "cxStarRatingEmpty": "Rating field is required",
    "cxNoSelectedItemToCancel": "Select at least one item",
    "cxNegativeAmount": "Amount must be equal or greater than zero",
    "cxContainsSpecialCharacters": "Field cannot contain special characters",
    "invalidTime": "Öffnungszeit muss im Format HH:MM angegeben sein",
    "min": "Menge darf nicht kleiner als {{min}} sein.",
    "date": {
      "required": "This field is required",
      "min": "Date cannot be before {{min}}",
      "max": "Date cannot be after {{max}}",
      "pattern": "Use dateformat yyyy-mm-dd",
      "invalid": "Use a valid date"
    }
  },
  "formLegend": {
      "required": "Die folgenden mit einem \"*\" gekennzeichneten Felder sind erforderlich."
  },
  "errorHandlers": {
    "scriptFailedToLoad": "Failed to load the script.",
    "refreshThePage": "Please refresh the page."
  } ,
   "customLoginPage": {
    "badRequest": {
      "bad_credentials": "Falsche Anmeldedaten. Bitte korrigieren Sie die Angaben und versuchen es erneut.",
      "account_disabled": "Der Benutzer wurde deaktiviert. Bitte kontaktieren Sie uns"
    }
  }
  
}
